import { render, staticRenderFns } from "./CustomizedThemeTemplate.vue?vue&type=template&id=0494318d&scoped=true"
import script from "./CustomizedThemeTemplate.vue?vue&type=script&lang=js"
export * from "./CustomizedThemeTemplate.vue?vue&type=script&lang=js"
import style0 from "./CustomizedThemeTemplate.vue?vue&type=style&index=0&id=0494318d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0494318d",
  null
  
)

export default component.exports